import { gql } from "@apollo/client";

export const getAllRegisteredMemberQuery = gql`
  query GetAllRegisteredMember(
    $pageNumber: Int!
    $pageSize: Int!
    $search: String
    $isBlocked: Boolean
  ) {
    getAllRegisteredMember(
      pageNumber: $pageNumber
      pageSize: $pageSize
      search: $search
      isBlocked: $isBlocked
    ) {
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
      data {
        id
        name
        email
        location_address
        phone_number
        emergency_contact_name
        emergency_contact_number
        profile
        authId
        role
        city
        zipCode
        state
        createdAt
        judgeStatus
      }
    }
  }
`;

export const getAllMembersForExportQuery = gql`
  query GetAllRegisteredMember(
    $pageNumber: Int!
    $pageSize: Int!
    $isBlocked: Boolean
  ) {
    getAllRegisteredMember(
      pageNumber: $pageNumber
      pageSize: $pageSize
      isBlocked: $isBlocked
    ) {
      totalCount
      data {
        name
        email
        role
      }
    }
  }
`;

export const updateUserRolesMutation = gql`
  mutation UpdateUserRoles($authId: String!, $role: [String!]!) {
    updateUserRoles(authId: $authId, role: $role) {
      message
    }
  }
`;
export const GET_USER_DETAIL = gql`
  query GetUserDetail($authId: String!) {
    getUserDetail(authId: $authId) {
      id
      name
      email
      location_address
      phone_number
      emergency_contact_name
      emergency_contact_number
      profile
      authId
      notes
      city
      state
      zipCode
      mark_as_paid
      role
      website
      distance_travel
      noofTrialJudged
      level
      createdAt
    }
  }
`;
export const GetUserDetail = gql`
  query GetUserDetail($authId: String!) {
    getUserDetail(authId: $authId) {
      name
      email
      location_address
      phone_number
      emergency_contact_name
      emergency_contact_number
      profile
      authId
      notes
      createdAt
      id
      role
      noofTrialJudged
      level
    }
  }
`;
export const GetCommonUserDetail = gql`
  query getCommonUserDetail($authId: String!) {
    getCommonUserDetail(authId: $authId) {
      id
      name
      email
      location_address
      phone_number
      emergency_contact_name
      emergency_contact_number
      profile
      authId
      notes
      mark_as_paid
      role
      website
      distance_travel
      noofTrialsHosted
      noOfTrialsParticipated
      noOfTrialsJudged
      level
      createdAt
      city
      zipCode
      state
      noOfUpcomingTrials
    }
  }
`;
export const UPDATE_USER_BY_ADMIN = gql`
  mutation UpdateUserByAdmin($authId: String!, $data: UpdateUserByAdminInput!) {
    updateUserByAdmin(authId: $authId, data: $data) {
      message
    }
  }
`;

export const GetTrailCalenderByAuthId = gql`
  query GetTrialCalendarByAuthId(
    $pageNumber: Int!
    $pageSize: Int!
    $search: String!
    $authId: String!
    $role: String!
  ) {
    getTrialCalendarByAuthId(
      pageNumber: $pageNumber
      pageSize: $pageSize
      authId: $authId
      role: $role
      search: $search
    ) {
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
      data {
        id
        name
        date
        location
        status
        noOfEntries
        dogEntries
        level
      }
    }
  }
`;

export const GetHostTrailCalender = gql`
  query GetHostOwnTrialCalendar($pageNumber: Int!, $pageSize: Int!) {
    getHostOwnTrialCalendar(pageNumber: $pageNumber, pageSize: $pageSize) {
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
      data {
        id
        authId
        noOfEntries
        level
        levelMap
        host {
          id
          hostName
          contactAddress
          city
          trialSecretaryName
          state
          trialSecretaryEmail
          zip
        }
        trial {
          id
          trialName
          trialLocationName
          trialLocationAddress
          city
          state
          zip
          timezone
          trialDate
          openDate
          closeDate
          trialFile
          description
          notes
          noOfJudge
          trialFees
          maxEntries
          trialImages
          judgeAuthId
          status
          approvalStatus
        }
        search {
          id
          level
          search
          searchName
          entryFee
          element
        }
      }
    }
  }
`;

export const UpdateNotes = gql`
  mutation UpdateUserNotes($authId: String!, $notes: String!) {
    updateUserNotes(authId: $authId, notes: $notes) {
      message
    }
  }
`;

export const UpdateJudgeLevel = gql`
  mutation UpdateJudgeLevel($authId: String!, $level: [String!]!) {
    updateJudgeLevel(authId: $authId, level: $level) {
      message
    }
  }
`;

export const DeleteUserByAuthId = gql`
  mutation DeactivateUser($authId: String!) {
    deactivateUser(authId: $authId) {
      message
    }
  }
`;

export const PermanentlyDeleteUser = gql`
  mutation DeleteUserPermanently($authId: String!) {
    deleteUserPermanently(authId: $authId) {
      message
    }
  }
`;

export const ReactivateUserByAuthId = gql`
  mutation ReactivateUser($authId: String!) {
    reactivateUser(authId: $authId) {
      message
    }
  }
`;
